/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Type_Maintenance_LogInputs */

const en_doc_type_maintenance_log = /** @type {(inputs: Doc_Type_Maintenance_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maintenance Log`)
};

const id_doc_type_maintenance_log = /** @type {(inputs: Doc_Type_Maintenance_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catatan Pemeliharaan`)
};

/** @type {(inputs: Doc_Type_Maintenance_LogInputs) => LocalizedString} */
const es_doc_type_maintenance_log = en_doc_type_maintenance_log;

/** @type {(inputs: Doc_Type_Maintenance_LogInputs) => LocalizedString} */
const fr_doc_type_maintenance_log = en_doc_type_maintenance_log;

/** @type {(inputs: Doc_Type_Maintenance_LogInputs) => LocalizedString} */
const de_doc_type_maintenance_log = en_doc_type_maintenance_log;

/** @type {(inputs: Doc_Type_Maintenance_LogInputs) => LocalizedString} */
const ja_doc_type_maintenance_log = en_doc_type_maintenance_log;

/** @type {(inputs: Doc_Type_Maintenance_LogInputs) => LocalizedString} */
const zh_doc_type_maintenance_log = en_doc_type_maintenance_log;

/** @type {(inputs: Doc_Type_Maintenance_LogInputs) => LocalizedString} */
const ar_doc_type_maintenance_log = en_doc_type_maintenance_log;

/** @type {(inputs: Doc_Type_Maintenance_LogInputs) => LocalizedString} */
const it_doc_type_maintenance_log = en_doc_type_maintenance_log;

/** @type {(inputs: Doc_Type_Maintenance_LogInputs) => LocalizedString} */
const ru_doc_type_maintenance_log = en_doc_type_maintenance_log;

/** @type {(inputs: Doc_Type_Maintenance_LogInputs) => LocalizedString} */
const pt_doc_type_maintenance_log = en_doc_type_maintenance_log;

/** @type {(inputs: Doc_Type_Maintenance_LogInputs) => LocalizedString} */
const ko_doc_type_maintenance_log = en_doc_type_maintenance_log;

/**
* | output |
* | --- |
* | "Maintenance Log" |
*
* @param {Doc_Type_Maintenance_LogInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const doc_type_maintenance_log = /** @type {((inputs?: Doc_Type_Maintenance_LogInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Type_Maintenance_LogInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_type_maintenance_log(inputs)
	if (locale === "es") return es_doc_type_maintenance_log(inputs)
	if (locale === "fr") return fr_doc_type_maintenance_log(inputs)
	if (locale === "de") return de_doc_type_maintenance_log(inputs)
	if (locale === "ja") return ja_doc_type_maintenance_log(inputs)
	if (locale === "zh") return zh_doc_type_maintenance_log(inputs)
	if (locale === "ar") return ar_doc_type_maintenance_log(inputs)
	if (locale === "id") return id_doc_type_maintenance_log(inputs)
	if (locale === "it") return it_doc_type_maintenance_log(inputs)
	if (locale === "ru") return ru_doc_type_maintenance_log(inputs)
	if (locale === "pt") return pt_doc_type_maintenance_log(inputs)
	return ko_doc_type_maintenance_log(inputs)
});